import { Component, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { decodeBase64ToText, encodeToBase64 } from '../../../utility';
import { OutcomesService } from '../outcomes.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.css'
})
export class UploadComponent {
  fileUploadForm: FormGroup;
  private outcomesService = inject(OutcomesService);
  private messageService = inject(MessageService);
  constructor() {
    // Initialize the form group with a form control for file input
    this.fileUploadForm = new FormGroup({
      file: new FormControl(null, Validators.required)
    });
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    this.fileUploadForm.patchValue({
      file: file
    });
  }

  onSubmit(event: Event): void {
    event.preventDefault();  // Prevent page reload
    if (this.fileUploadForm.valid) {
      const file = this.fileUploadForm.get('file')?.value;
      // You can upload the file or handle the file here


      const fileUpload = { payload: encodeToBase64(JSON.stringify(file)) };
      this.outcomesService.uploadFile(file).subscribe(
        (data: any) => {
          const parsedData = data;
            if(parsedData.error){
              this.messageService.add({ severity: 'warn', summary: 'Warn', detail: parsedData.message });
            } else {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: parsedData.message });
            }
        },
        (error) => {
          console.error('Error fetching upload file', error);
        }
      );
    }
  }

}
